/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable no-console */

import { toast } from "react-toastify";
import { toastSettings } from "../components/App/App.styled";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export const updateTableInfo = async (id: string, newName: string, tableId: string | null) => {

    try {
        // Send the POST request using fetch
        const response = await fetch(`${API_ENDPOINT}/post/update-table`, {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
            },
            body: JSON.stringify({
                id: id,
                newName: newName,
                tableId: tableId
            }),
        });

        // Check if the request was successful
        const result = await response.json();
        if (response.ok) {
            toast('Table updated successfully!', toastSettings);
        } else {
            toast.error('Error updating table', toastSettings);
        }
        return result;
    } catch (error) {
        toast.error('Error updating table', toastSettings);
        return null;
    }
};